module.exports = __webpack_public_path__ + "MaterialIcons-Regular.ttf?a37b0c01c0baf1888ca812cc0508f6e2";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/style/icon/MaterialIcons-Regular.ttf
// module id = 272
// module chunks = 0